import InfrastructureTable from './InfrastructureTable';
import Content from './Content';
import SelectorContainer from './SelectorContainer';

/**
 * Infrastructure table with compound components pattern.
 *
 * **Basic usage (read-only table):**
 * ```jsx
 * <InfrastructureTable
 *   title={<Trans>Interfaces</Trans>}
 *   tableId="device-interfaces"
 *   emptyStateMessage="No interfaces found"
 *   fetchUrl="/api/interfaces"
 *   fetchParams={{ deviceId }}
 *   columns={columns}
 * >
 *   <InfrastructureTable.Content />
 * </InfrastructureTable>
 * ```
 *
 * **With selection and actions:**
 * ```jsx
 * <InfrastructureTable {...baseProps}>
 *   <InfrastructureTable.SelectorContainer>
 *     <InfrastructureTable.Content enableSelection actionMenus={menus} />
 *   </InfrastructureTable.SelectorContainer>
 * </InfrastructureTable>
 * ```
 *
 * **Benefits:**
 * - Zero boolean props on parent (down from 7)
 * - Flexible composition - include only what you need
 * - Clearer intent - presence of component shows feature is enabled
 * - Better maintainability - each compound component focused on single concern
 * - Aligns with React 18 best practices
 *
 * **Compound components:**
 * - `InfrastructureTable.Content` - Renders the actual table (DataTable or ListActionSelector)
 * - `InfrastructureTable.SelectorContainer` - Wraps content in styled container
 */
// Attach compound components as properties (Compound Component pattern)
InfrastructureTable.Content = Content;
InfrastructureTable.SelectorContainer = SelectorContainer;

export default InfrastructureTable;
